import { render, staticRenderFns } from "./tabs.vue?vue&type=template&id=b0df63f0&scoped=true"
import script from "./tabs.vue?vue&type=script&setup=true&lang=js"
export * from "./tabs.vue?vue&type=script&setup=true&lang=js"
import style0 from "./tabs.vue?vue&type=style&index=0&id=b0df63f0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@2.7.16_babel-core@6.26.3_css-loader@6.10.0_webpack_ea28be7e1d4dd58e236d0f38167ec61d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0df63f0",
  null
  
)

export default component.exports